export default __webpack_public_path__ + "static/media/LAS0700.34I-30427_-17564_0.b2ddb573.jpg";